/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-05 17:46:05
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/CloneButton/index.tsx
 */
import React from 'react';
import Button from 'src/components/CloneButton';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchContentShoppingCart } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/slice';
import { useCloneBtnParams } from 'src/hooks/useCloneBtnParams';
import style from '../css.less';

const CloneBtn = (props) => {
  //asd
  const params: any = useParams();
  const { contentUuid } = params;
  const _d = useDispatch();
  const _params = useCloneBtnParams();

  const handleOnClick = () => {
    _d(
      fetchContentShoppingCart({
        //1===true 0===false
        uuid: contentUuid,
        params: _params,
        isClone: true,
      }),
    );
  };
  return (
    <Button
      onClick={handleOnClick}
      disabled={props?.disabled}
      className={style.cloneBtnWidth}
    />
  );
};
export default CloneBtn;
